import type { RailLayout } from "@/data/rail-branches";
import { timelineRailAxisY } from "../../marker/MarkerMetrics/metrics";
import type { LocationRun } from "../LocationRun/runs";
import { LOCATION_BOX_STEP_PX } from "../LocationMarker/stack";
import { railLaneOffsetY } from "../../rail/RailLanes/lanes";
import { computeSceneMotion } from "@/lib/timeline/scene/SceneMotion/motion";

/** Boxes start here below the rail. The cast sits above it, so the rail shows between them. */
const LOCATION_BELOW_RAIL_PX = 24;

export function sceneStartMarkerCenterX(
  startMs: number,
  viewportWidth: number,
  totalDurationMs: number,
): number {
  return computeSceneMotion(startMs, viewportWidth, totalDurationMs).groupCenterX;
}


export function timelineLocationBoxTopY(lane = 0, offsets?: Record<string, number>): number {
  return timelineRailAxisY() + railLaneOffsetY(lane, offsets) + LOCATION_BELOW_RAIL_PX;
}

/** Under this line's rail, whoever is on it. */
export function locationStackTopY(rail: RailLayout, run: LocationRun): number {
  const lane = run.lane ?? 0;
  const branch = rail.branches.find((item) => (
    item.lane === lane && item.startMs <= run.startMs && run.startMs < item.endMs
  ));
  return timelineLocationBoxTopY(lane, branch?.laneOffsets);
}

/** Upcoming part on the rail lines up with the cast secondary slot. */
export function locationPartRailTopY(rail: RailLayout, branchRun: LocationRun): number {
  return locationStackTopY(rail, branchRun) + LOCATION_BOX_STEP_PX;
}

/** Under the rail this person is on, including while they travel a fork. */
export function locationStackTopYBelowMarkerPose(pose: { railDy: number }): number {
  return timelineRailAxisY() + pose.railDy + LOCATION_BELOW_RAIL_PX;
}
